import { FC, memo } from 'react';
import styles from './index.less';
import { repairStatusMap, repairStatusEnum } from '@/pages/RepairManage/config';
import type { RepairDetailItemType } from '@/pages/RepairManage/config';
import { Divider } from 'antd-mobile';

interface DetailProps {
  detailItems?: Partial<RepairDetailItemType>;
  /**重发*/
  refreshSendClick: () => void;
  /**编辑*/
  editClick: (id: string) => void;
  /**撤销*/
  cancelClick: () => void;
}
const Detail: FC<DetailProps> = ({
  detailItems,
  refreshSendClick,
  editClick,
  cancelClick,
}) => {
  const showDivider = (item: RepairDetailItemType): boolean => {
    switch (item.status) {
      case repairStatusEnum.CANCEL:
      case repairStatusEnum.REVOKE:
      case repairStatusEnum.BACK:
      case repairStatusEnum.REVIEW:
        return true;
      default:
        return false;
    }
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.tag}
        style={{
          backgroundColor:
            detailItems &&
            repairStatusMap[detailItems.status!]?.backGroundColor,
          color: detailItems && repairStatusMap[detailItems.status!]?.textColor,
        }}
      >
        <img
          src={detailItems && repairStatusMap[detailItems.status!].icon}
          alt={'icon'}
        />
        <span>{detailItems && repairStatusMap[detailItems.status!].text}</span>
      </div>
      <div className={styles.content}>
        <div className={styles.nav}>{detailItems?.content}</div>
        <img src={detailItems?.imgUrl} alt={'img'} />
        <div className={styles.address}>{detailItems?.address}</div>

        {detailItems?.status === repairStatusEnum.BACK ||
        detailItems?.status === repairStatusEnum.CANCEL ? (
          <>
            <Divider
              style={{
                borderStyle: 'dashed',
                borderColor: '#E8E8E8',
                margin: '10px 0',
              }}
            />
            <div className={styles.reason}>
              <div>
                <p>
                  {detailItems?.status === repairStatusEnum.BACK
                    ? '退回'
                    : '关闭'}
                  原因：
                </p>
                <span>{detailItems?.backReason}</span>
              </div>
              <div>
                <p>
                  {detailItems?.status === repairStatusEnum.BACK
                    ? '退回'
                    : '关闭'}
                  时间：{detailItems?.backTime}
                </p>
              </div>
            </div>
          </>
        ) : undefined}
      </div>
      {showDivider(detailItems! as RepairDetailItemType) && (
        <div className={styles.divider} />
      )}
      {/*被退回*/}
      {detailItems?.status === repairStatusEnum.BACK && (
        <div className={styles.btn}>
          <div onClick={() => editClick(detailItems.id!)}>
            <img src={require('@/assets/repair/editIcon.png')} alt={'edit'} />
            <span>编辑</span>
          </div>
          <div onClick={cancelClick}>
            <img
              src={require('@/assets/repair/cancelIcon.png')}
              alt={'cancel'}
            />
            <span>撤销</span>
          </div>
        </div>
      )}
      {/*  已撤销*/}
      {detailItems?.status === repairStatusEnum.REVOKE && (
        <div className={styles['default-btn']}>
          <div onClick={refreshSendClick}>
            <img
              src={require('@/assets/repair/refreshSend.png')}
              alt={'refresh-send'}
            />
            <span>重发</span>
          </div>
        </div>
      )}
      {/*  待审核*/}
      {detailItems?.status === repairStatusEnum.REVIEW && (
        <div className={styles['default-btn']}>
          <div onClick={cancelClick}>
            <img
              src={require('@/assets/repair/cancelIcon.png')}
              alt={'cancel'}
            />
            <span>撤销</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(Detail);
